import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Building2, Stethoscope, Pill, Briefcase, GraduationCap, Plane, Landmark } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function UseCases() {
    const { t } = useTranslation();
    const CASES = [
        { icon: Building2, key: "hospitals" },
        { icon: Stethoscope, key: "clinics" },
        { icon: Pill, key: "pharmacies" },
        { icon: Briefcase, key: "corporate" },
        { icon: GraduationCap, key: "schools" },
        { icon: Plane, key: "airports" },
        { icon: Landmark, key: "government" },
    ];
    return (
        <div className="bg-white" data-testid="use-cases-page">
            <Navbar />
            <main className="pt-28">
                <section className="max-w-7xl mx-auto px-6 md:px-12 py-12">
                    <div className="text-xs font-mono tracking-[0.22em] text-[var(--medx-red)] mb-4">{t("useCases.eyebrow")}</div>
                    <h1 className="font-display text-5xl md:text-7xl font-bold tracking-tighter max-w-4xl mb-6">
                        {t("useCases.title")}
                    </h1>
                    <p className="text-lg text-gray-600 max-w-2xl leading-relaxed">
                        {t("useCases.intro")}
                    </p>
                </section>

                <section className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 pb-16">
                    {CASES.map((c, i) => {
                        const Icon = c.icon;
                        return (
                            <div key={i} className="relative card-soft p-7 overflow-hidden group" data-testid={`use-case-${i}`}>
                                <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-[var(--medx-red)] to-[var(--medx-orange)] origin-left scale-x-0 group-hover:scale-x-100 transition-transform" />
                                <Icon className="w-9 h-9 text-[var(--medx-red)] mb-4" />
                                <div className="font-display text-2xl font-semibold mb-2">{t(`useCases.items.${c.key}.title`)}</div>
                                <div className="text-sm text-gray-600 leading-relaxed mb-5">{t(`useCases.items.${c.key}.desc`)}</div>
                                <div className="inline-block px-3 py-1 rounded-full bg-orange-50 text-[var(--medx-red)] text-xs font-mono">{t(`useCases.items.${c.key}.kpi`)}</div>
                            </div>
                        );
                    })}
                </section>
            </main>
            <Footer />
        </div>
    );
}
